
import { Vue, Component } from 'vue-property-decorator'
import Element from '@/types/element'
import ElementEditDetailsTab from '@/views/element/tabs/edit/ElementEditDetailsTab.vue'
import ElementEditSubelementsTab from '@/views/element/tabs/edit/ElementEditSubelementsTab.vue'
import ls from '@/ls'

@Component({
  components: { ElementEditSubelementsTab, ElementEditDetailsTab }
})

export default class ElementEdit extends Vue {
  settings = {
    routeNames: { list: 'elements', show: 'elementShow', edit: 'elementEdit' },
    routeParamKey: 'elementId',
    functionNames: { setCurrent: 'setCurrentElement', clearCurrent: 'clearCurrentElement', save: 'saveElement' },
    getterNames: { current: 'currentElement', loading: 'loadingElement' }
  }

  currentTab:string = ls.get('elementEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('elementEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : Element {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
